import { useState, useCallback } from 'react';
import { previewCommentMail } from '@/api/ticket';
import { useLoadingStore } from '@/stores/loading';

export interface EmailPreviewData {
  comment: string;
  ticketId?: number;
  userId: number;
  destinationId: number;
  customerId?: number;
  dataId?: number;
}

export interface EmailPreview {
  subject: string;
  html: string;
}

export const useEmailPreview = (previewData?: EmailPreviewData) => {
  const setLoading = useLoadingStore((state) => state.setLoading);
  const [error, setError] = useState<string | null>(null);
  const [preview, setPreview] = useState<EmailPreview | null>(null);

  const fetchPreview = useCallback(async () => {
    if (!previewData) return;

    setLoading(true);
    setError(null);

    try {
      // APIリクエスト用のデータを構築
      const requestData = {
        comment: previewData.comment,
        ticket_destinations_id: previewData.destinationId,
        is_inquiry_user: false, // 管理者側からの送信として固定
        created_by: previewData.userId,
        data_ticket_id: previewData.ticketId,
        ...(previewData.customerId 
          ? { customer_id: previewData.customerId }
          : { data_id: previewData.dataId }
        )
      };

      const response = await previewCommentMail(requestData);
      
      if (response.data.status === 1) {
        setPreview(response.data.data);
      } else {
        setError(response.data.message || 'メールプレビューの取得に失敗しました');
      }
    } catch (err: any) {
      console.error('Email preview error:', err);
      setError('メールプレビューの取得に失敗しました');
    } finally {
      setLoading(false);
    }
  }, [previewData, setLoading]);

  return { error, preview, fetchPreview };
};